import {type Invite, getInviteFromSearchParams, isValidInvite} from '@/types/invite';
import {useSession} from 'next-auth/react';
import {useSearchParams} from 'next/navigation';
import {useEffect, useMemo, useRef} from 'react';

export default function useInvite() {
  const searchParams = useSearchParams();
  const searchParamsString = searchParams.toString();
  const {data: session, update} = useSession();
  const hasUpdatedSession = useRef<boolean>(false);

  const invite = useMemo<Invite | null>(() => {
    if (session?.user?.invite && isValidInvite(session.user.invite)) {
      return session.user.invite;
    }

    if (searchParams.size > 0) {
      const result = getInviteFromSearchParams(searchParams);

      if (result != null && isValidInvite(result)) {
        return result;
      }
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session, searchParamsString]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    (async () => {
      try {
        if (session?.user && invite && !hasUpdatedSession.current) {
          // prevent useEffect loop
          hasUpdatedSession.current = true;

          await update({
            ...session,
            user: {
              ...session.user,
              invite,
            },
          });
        }
      } catch (err) {
        console.error('Failed to update session:', err);
      }
    })();
  }, [invite, session, update]);

  return invite;
}
